import { useEffect, useState } from 'react';
import beep from '../utils/beep';
import { api } from '../services/api';

export interface Notification {
    id: number;
    type: string;
    message: string;
    is_read: boolean;
    header?: string;
    image?: string;
    related_user_id: number | null;
    related_badge_id: number | null;
    created_at: string;
    updated_at: string;
}

export function useNotifications() {
    const [notifications, setNotifications] = useState<Notification[]>([]);
    const [unreadCount, setUnreadCount] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const itemPerPage = 10;

    const fetchNotifications = async (page = currentPage) => {
        setIsLoading(true);
        try {
            const response = await api.notifications.notifications.getNotifications(page, itemPerPage);
            const data = response.notifications || [];
            // // Play beep if new notifications are detected
            // if (notifications.length > 0 && data.length > notifications.length) {
            //     beep();
            // }
            setNotifications(data);
            setUnreadCount(response.unread_count || 0);
            setTotalPages(response.total_pages || 0);
            setTotalCount(response.count || 0);
        } catch (error) {
            console.error('Error fetching notifications:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const markAsRead = async (notificationId?: number) => {
        try {
            await api.notifications.notifications.markAsRead(notificationId);
            fetchNotifications(currentPage);
        } catch (error) {
            console.error('Error marking notification as read:', error);
        }
    };

    const markAllAsRead = async () => {
        try {
            await api.notifications.notifications.markAllNotificationsRead();
            fetchNotifications(currentPage);
        } catch (error) {
            console.error('Error marking all notifications as read:', error);
        }
    };

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
        fetchNotifications(page);
    };

    useEffect(() => {
        fetchNotifications();
        const interval = setInterval(() => fetchNotifications(currentPage), 30000); // Poll every 30 seconds
        return () => clearInterval(interval);
    }, [currentPage]);

    return {
        notifications,
        unreadCount,
        isLoading,
        currentPage,
        totalPages,
        totalCount,
        markAsRead,
        markAllAsRead,
        handlePageChange,
        refetch: fetchNotifications,
    };
}